<div class="dialog-container">
    <div class="dialog-title-block">
      <h2>Edit Device Unique Name</h2>
      <div class="dialog-close-btn" (click)="onClose()">
        <img src="../../../assets/images/close.png" alt="close">
      </div>
    </div>
    <form (ngSubmit)="editDesktop()">
      <div class="dialog-content-block">
        <div>
          <p>This Desktop Unique Name will be used across the product for identification.</p>
        </div>
        <div class="content d-flex flex-column">
          <label for="u_name" class="mb-2">Desktop Unique Name</label>
          <input
            type="text"
            placeholder="Desktop Unique Name"
            [(ngModel)]="desktop.name"
            name="u_name"
            required
          />
          <span *ngIf="errorMessage !== ''" class="text-xs text-missing">{{ errorMessage }}</span>
        </div>
      </div>
      <div class="dialog-footer">
        <button type="button" (click)="onClose()">Cancel</button>
        <button type="submit">Update</button>
      </div>
    </form>
  </div>
  